(function($, undefined) {
	
	'use strict';
	
	var toggleAdminBox = function() {
		var t = $(this);
		var parent = t.closest('.admin-box-ctn');
		var child = parent.find('.admin-box-expand-ctn');
			
		parent.toggleClass('active');
		child.slideToggle(300);
		
		/*if(parent.hasClass('active')){
			parent.removeClass('active');
			child.slideUp('slow');
		}
		else {
			parent.addClass('active');
			child.slideDown('slow');
		}*/
	};
	
	var init = function () {
		$('.admin-box-title').on('click', toggleAdminBox);
	};
	
	$(window).ready(function () {
		init();
	});
	
})(jQuery);
